import React from "react";
import * as styles from "@styles/DocumentSelection.css";
import type { DocumentSelectionViewProps } from "@ps-bridge/contracts/documentSelection";
import type { DocumentMetadata } from "@ps-bridge/models/core/dataContracts";
import type { DocumentListSectionPhase } from "@ps-bridge/models/documents/documentListSectionPhase";
import DocumentListSectionPanel from "@view/panels/workspace/document-selection/DocumentListSection.panel";

export type DocumentListSectionInput = {
  phase: DocumentListSectionPhase;
  title: string;
  documents: DocumentMetadata[];
};

type DocumentListContractProps = Pick<DocumentSelectionViewProps, never>;

type DocumentListViewProps = DocumentListContractProps & {
  sections: DocumentListSectionInput[];
  isGridView: boolean;
  renderDocumentItem: (doc: DocumentMetadata) => React.ReactElement;
};

const DocumentListView: React.FC<DocumentListViewProps> = ({
  sections,
  isGridView,
  renderDocumentItem,
}) => {
  const gridClassName = isGridView ? styles.gridContainer : "";

  return (
    <div className={styles.documentList}>
      {sections.map((section) => (
        <DocumentListSectionPanel
          key={section.title}
          phase={section.phase}
          title={section.title}
          documents={section.documents}
          gridClassName={gridClassName}
          renderDocumentItem={renderDocumentItem}
        />
      ))}
    </div>
  );
};

export default DocumentListView;
